export enum ApplicationSource {
  Registration = 'registration',
  QuickSignup = 'quick_signup',
  JobBoard = 'job-board',
  TransparentRegistration = 'transparent_registration',
  MultipostingRegistration = 'multiposting_registration',
  PausedJobPage = 'paused_job_page',
  EmployerPage = 'employer_page',
  JobDetailsPage = 'job_details_page',
  UnconfirmedJobBoard = 'unconfirmed-job-board',
  PremiumLandingPage = 'premium_landing_page',
  ReactivationEmail = 'reactivation_email',
  Carousel = 'carousel',
  TransparentJobBoard = 'transparent_job_board',
  TransparentJobDetailsPage = 'transparent_job_details_page',
  Blog = 'blog',
  SuggestionsModal = 'suggestions_modal',
  SalaryCalculator = 'salary_calculator_job_carousel',
  RecommendedDashboard = 'recommended_dashboard',
  RecommendedApplications = 'recommended_applications',
}
